import type { DatavaultConstructType, VaultEntityKind } from "./types";

const normalizeConstruct = (value: string | null | undefined) =>
  (value ?? "").trim().toLowerCase();

export const getConstructTypeForState = (
  kind: VaultEntityKind,
  isVirtualized: boolean
): DatavaultConstructType => {
  if (kind === "hub") {
    return isVirtualized ? "HubAsView" : "HubAsTable";
  }
  if (kind === "satellite") {
    return isVirtualized ? "SatAsView" : "SatAsTable";
  }
  return isVirtualized ? "LinkAsView" : "LinkAsTable";
};

export const isHubConstruct = (value: string | null | undefined) =>
  normalizeConstruct(value).startsWith("hub");

export const isSatelliteConstruct = (value: string | null | undefined) => {
  const normalized = normalizeConstruct(value);
  return normalized.startsWith("sat") || normalized.startsWith("satellite");
};

export const isLinkConstruct = (value: string | null | undefined) =>
  normalizeConstruct(value).startsWith("link");

export const isManualConstruct = (value: string | null | undefined) =>
  normalizeConstruct(value).startsWith("manual");

export const isVirtualizedConstruct = (value: string | null | undefined) =>
  normalizeConstruct(value).includes("view");
